module.exports = "/assets/logo_sg_substance_sampler-4f2d5a0e47e6f2224d778e21582433f5.png";